<template src="./Login.html"></template>

<script>
import ArrobaMedellinLogo from "@/components/Icons/ArrobaMedellinLogo";
import {
  DOCUMENT_TYPE_OPTIONS,
  EVENT_ACTIVITY_OPTIONS,
  HOW_DID_YOU_HEAR_OPTIONS,
  OCCUPATION_OPTIONS,
  SEX_OPTIONS,
} from "@/constants/registration";
import countriesData from "@/data/countries.json";
import departmentsData from "@/data/departments.json";
import { nodeInstance, phpInstance } from "@/plugins/axios";
import LoginService from "@/services/Login";
import userService from "@/services/User";
import { autoAssociateArrobaId } from "@/utils/arrobaId";
import { roleName } from "@/utils/constants";
import { email, minLength, numeric, required } from "vuelidate/lib/validators";
import locationService from "../../services/Locations";

export default {
  name: "login",
  components: { ArrobaMedellinLogo },
  data() {
    return {
      infoLogin: {
        document: "",
        password: "",
      },
      showPassword: false,
      dataUser: {
        names: "",
        surnames: "",
        email: "",
        documentType: "",
        document: "",
        birthDate: "",
        sex: "",
        country: "Colombia",
        province: "",
        city: "",
        occupation: "",
        otherOccupation: "",
        eventActivity: "",
        howDidYouHear: "",
        otherHowDidYouHear: "",
      },
      showLoginState: true,
      showSignUp: false,
      registrationStep: 1,
      successful: false,
      loginError: false,
      loginErrorMessage: "",
      roleName,
      getStates: [],
      getCities: [],
      getCountries: countriesData.data,
      getDepartments: departmentsData.data,
      userRegister: null,
      documentTypeOptions: DOCUMENT_TYPE_OPTIONS,
      sexOptions: SEX_OPTIONS,
      occupationOptions: OCCUPATION_OPTIONS,
      howDidYouHearOptions: HOW_DID_YOU_HEAR_OPTIONS,
      eventActivityOptions: EVENT_ACTIVITY_OPTIONS,
    };
  },
  validations() {
    const infoLogin = {
      document: { required },
      password: { required, minLength: minLength(6) },
    };
    const dataUser = {
      names: { required },
      surnames: { required },
      email: { email, required },
      documentType: { required },
      document: { required, numeric },
      birthDate: { required },
      sex: { required },
      country: { required },
      province: { required },
      city: { required },
      occupation: { required },
      eventActivity: {},
      howDidYouHear: { required },
    };
    if (this.showLoginState) {
      return { infoLogin };
    }
    if (this.showSignUp) {
      return { dataUser };
    }
  },
  created() {
    this.getStatesChange();
  },
  computed: {
    filteredDepartments() {
      if (this.dataUser.country === "Colombia") {
        return this.getDepartments;
      }
      return [];
    },
    showOtherOccupation() {
      return this.dataUser.occupation === "otro";
    },
    showOtherHowDidYouHear() {
      return this.dataUser.howDidYouHear === "otro";
    },
    isStep1Valid() {
      return (
        !this.$v.dataUser.documentType.$invalid &&
        !this.$v.dataUser.document.$invalid &&
        !this.$v.dataUser.names.$invalid &&
        !this.$v.dataUser.surnames.$invalid &&
        !this.$v.dataUser.email.$invalid &&
        !this.$v.dataUser.sex.$invalid
      );
    },
    isStep2Valid() {
      return (
        !this.$v.dataUser.country.$invalid &&
        !this.$v.dataUser.province.$invalid &&
        !this.$v.dataUser.city.$invalid &&
        !this.$v.dataUser.birthDate.$invalid &&
        !this.$v.dataUser.occupation.$invalid &&
        !this.$v.dataUser.howDidYouHear.$invalid
      );
    },
  },
  methods: {
    nextStep() {
      if (this.registrationStep === 1 && this.isStep1Valid) {
        this.registrationStep = 2;
      } else {
        this.$v.dataUser.$touch();
      }
    },
    prevStep() {
      if (this.registrationStep > 1) {
        this.registrationStep--;
      }
    },
    goToHome() {
      const ram = navigator.deviceMemory;
      if (ram === 8) {
        this.$store.dispatch("fetchInitialHome", true);
      } else if (
        navigator.platform.indexOf("Mac") === 0 ||
        navigator.platform === "iPhone"
      ) {
        this.$store.dispatch("fetchInitialHome", false);
      } else {
        this.$store.dispatch("fetchInitialHome", false);
      }
    },
    showLogin() {
      this.showLoginState = true;
      this.showSignUp = false;
      this.dataUser = {};
    },
    async login() {
      this.$store.dispatch("fetchLoading", true);
      try {
        const auth = await LoginService.auth({
          document: this.infoLogin.document,
          password: this.infoLogin.password,
        });
        if (auth.message) {
          this.loginError = true;
          this.loginErrorMessage = auth.message;
          return false;
        }
        const {
          tokenNode,
          tokenPhp,
          userController: { flag },
          users: [user],
        } = auth;
        nodeInstance.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${tokenNode}`;
        phpInstance.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${tokenPhp}`;
        this.$store.dispatch("fetchTokenControllerNode", tokenNode);
        this.$store.dispatch("fetchTokenControllerPhp", tokenPhp);
        this.$store.dispatch("fetchUserRole", auth.users);
        if (flag == 0) {
          this.$router.push("/changePasswordUserController");
        } else if (auth.users.length === 0) {
          throw "El usuario no tiene roles";
        } else {
          const infoUser = await LoginService.getUserAuthByRol({
            userId: JSON.stringify(user.id),
            token: tokenPhp,
          });
          if (
            !infoUser.user.institutionId &&
            infoUser.role !== this.roleName.INVITED
          ) {
            this.$router.push("/sinInstituciones");
          } else {
            this.$store.dispatch("fetchUser", infoUser.user);
            this.$store.dispatch("fetchJwt", infoUser.tokenNode);
            this.$store.dispatch("fetchToken", infoUser.tokenPhp);
            nodeInstance.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${infoUser.tokenNode}`;
            phpInstance.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${infoUser.tokenPhp}`;
            const flagUser = infoUser.user.arrobaId;
            if (flagUser) {
              this.$store.dispatch("fetchAuth", true);
              this.goToHome();
            } else {
              if (
                infoUser.role === this.roleName.TEACHER ||
                infoUser.role === this.roleName.STUDENT
              ) {
                // Asociar el @ID en silencio; si falla (ya se registra en
                // consola) se entra al home igual.
                const atId = await autoAssociateArrobaId();
                if (atId) {
                  this.$store.dispatch("fetchUser", {
                    ...infoUser.user,
                    arrobaId: atId,
                  });
                }
              }
              this.$store.dispatch("fetchAuth", true);
              this.goToHome();
            }
          }
        }
      } catch (e) {
        console.error(e);
        this.loginError = true;
        this.$buefy.toast.open({
          duration: 5000,
          message: e.response?.data?.message ?? "Ocurrio un error",
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    redirectTo(route) {
      this.$router.push({ path: `${route}` });
    },
    showRegister() {
      this.showLoginState = false;
      this.showSignUp = true;
    },
    showLogon() {
      this.showLoginState = true;
      this.showSignUp = false;
      this.dataUser = {};
    },
    async signIn() {
      try {
        const ojbData = {
          documento: this.dataUser.document,
          tipo_documento: this.dataUser.documentType,
          nombres: this.dataUser.names,
          email_contacto: this.dataUser.email,
          apellidos: this.dataUser.surnames,
          departamento: this.dataUser.province,
          ciudad: this.dataUser.city,
          clave: this.dataUser.document,
          genero: this.dataUser.sex,
          fecha_nacimiento: this.dataUser.birthDate,
          sexo: this.dataUser.sex,
          pais: this.dataUser.country,
          ocupacion: this.dataUser.occupation,
          otra_ocupacion: this.dataUser.otherOccupation || null,
          evento_actividad: this.dataUser.eventActivity,
          como_se_entero: this.dataUser.howDidYouHear,
          otro_como_se_entero: this.dataUser.otherHowDidYouHear || null,
        };
        const user = await userService.registerUserCampus(ojbData);
        this.userRegister = user;
        this.$buefy.toast.open({
          duration: 5000,
          message: "Usuario creado",
          position: "is-bottom",
          type: "is-primary",
        });
        await userService.sendRegistrationConfirmation(user.id);
        this.successful = true;
        this.showLoginState = false;
        this.showSignUp = false;
      } catch (error) {
        console.error(error);
        this.$buefy.toast.open({
          duration: 5000,
          message: error.response?.data?.message ?? "Ocurrio un error",
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    async forwardMailCredentials() {
      try {
        await userService.sendRegistrationConfirmation(this.userRegister.id);
        this.$buefy.toast.open({
          duration: 5000,
          message: "Correo enviado",
          position: "is-bottom",
          type: "is-primary",
        });
      } catch (error) {
        console.error(error);
        this.$buefy.toast.open({
          duration: 5000,
          message: error.response?.data?.message ?? "Ocurrio un error",
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    async getStatesChange() {
      try {
        this.getStates = await locationService.getStates("Colombia");
      } catch (e) {
        console.error("error", e);
      }
    },
    async getCitiesChange(country, state) {
      try {
        this.getCities = await locationService.getCities(country, state);
      } catch (e) {
        console.error("error", e);
      }
    },
    onCountryChange() {
      this.dataUser.province = "";
      this.dataUser.city = "";
      this.getCities = [];
    },
    onProvinceChange() {
      this.dataUser.city = "";
      if (this.dataUser.province) {
        this.getCitiesChange(this.dataUser.country, this.dataUser.province);
      }
    },
    signInTwo() {
      this.showSignUp = false;
      this.successful = false;
      this.showLoginState = true;
      this.dataUser = {};
    },
  },
};
</script>

<style lang="scss" src="./Login.scss" scoped></style>
